export default __webpack_public_path__ + "c9fe21a048f965c450f7334393afcb7d.svg";